import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { ArrowBack } from './'
import { ButtonReturnCard } from './../styles'

class ReturnButton extends Component {
  handlerClick = (e) => {
    e.preventDefault()
    this.props.history.goBack()
  }
  render() {
    const {big} = this.props
    return (
      <button className={`btn btn-return ${ButtonReturnCard(big)}`} onClick={this.handlerClick}>
        <ArrowBack width={24} height={24} />
      </button>
    )
  }
}

export default withRouter(ReturnButton)


// WEBPACK FOOTER //
// ./src/components/ReturnButton.js